import config from '../../config';
import api from '../../helper/api';
import store from '../index';

const processProfileData = function (profile) {
    if (typeof profile.picture == 'string') {
        const updatedAt = 'updated_at' in profile ? new Date(profile.updated_at) : new Date();
        profile.picture = profile.picture + '?t=' + updatedAt.getTime();
    }

    return profile;
}

export default {
    settings: {
        persist: {
            storage: 'local',
        },
        persistDistinct: {
            data: {
                storage: 'db',
                storageKey: 'flattened',
                mode: 'flatten',
                getter: state => {
                    const profilePictureIsBlob = state && state.profile && state.profile.picture instanceof Blob ? true : false;

                    return {
                        profile: {
                            picture: profilePictureIsBlob ? state.profile.picture : undefined
                        }
                    };
                }
            },
            userDataUpdating: {
                storage: false // do not store the updating promise in the persistent storage
            }
        }
    },

    module: {
        namespaced: true,

        state: {
            data: null,
            accessToken: null,
            refreshToken: null,
            notificationsHash: null,
            allowUpdateFromSource: true,
            userDataUpdating: null
        },
        getters: {
            loggedIn: state => {
                return state.data != null && state.accessToken != null;
            },
            profile: state => {
                return state.data ? state.data.profile : null;
            },
            profilePicture: state => {
                let profilePicture = state.data && state.data.profile.picture ? state.data.profile.picture : null;

                if (profilePicture && profilePicture instanceof Blob) {
                    return URL.createObjectURL(profilePicture);
                }

                return profilePicture ? profilePicture : config.user.profilePictureFallback;
            }
        },
        mutations: {
            login(state, data) {
                state.data = data.user;
                state.accessToken = data.access_token;
                state.refreshToken = data.refresh_token;
                state.notificationsHash = data.notifications_hash;
            },
            logout(state) {
                state.data = null;
                state.accessToken = null;
                state.refreshToken = null;
            },
            updateData(state, data) {
                if ('profile' in data) {
                    data.profile = processProfileData(data.profile);
                }

                state.data = data;
            },
            updateProfile(state, newData) {
                if (state.data) {
                    state.data.profile = processProfileData(newData);
                }
            },
            allowUpdateFromSource(state) {
                state.allowUpdateFromSource = true;
            },
            disallowUpdateFromSource(state) {
                state.allowUpdateFromSource = false;
            }
        },
        actions: {
            updateFromSource({ state, getters, dispatch }) {
                state.userDataUpdating = new Promise((resolve, reject) => {
                    if (state.allowUpdateFromSource) {
                        if (getters.loggedIn) {

                            dispatch('tasks/runUnique', api.get('user').name('getUserData'), { root: true })
                                .then(apiResponse => {
                                    resolve();

                                    return apiResponse;
                                })
                                .then('store::commit:user/updateData')
                                .catch(apiResponse => {
                                    if (apiResponse.networkError) {
                                        reject('offline');
                                    } else {
                                        reject(apiResponse.message);
                                    }
                                })
                                .deferred(() => {
                                    reject('deferred');
                                });
                        } else {
                            reject('notLoggedIn');
                        }
                    } else {
                        reject('notAllowed');
                    }
                });

                return state.userDataUpdating;
            }
        }
    }
}